"use client";

import styled from "styled-components";
import { spacing8, spacing16, spacing24, borderColorSecondary, backgroundColorLevelCurrent } from "@churchofjesuschrist/eden-style-constants";
import { Icon } from "@churchofjesuschrist/eden-buttons";
import { Clear } from "@churchofjesuschrist/eden-icons";
import { H5 } from "@churchofjesuschrist/eden-headings";
import { mediaBreak480w } from "@churchofjesuschrist/eden-styled-helpers";
import { Fade, Scrollable } from "@churchofjesuschrist/eden-fade";
import Dialog from "@churchofjesuschrist/eden-platform-modal";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const PadBox = styled.div.withConfig({
  componentId: "sc-1aym6or-0"
})(["padding:0 ", ";padding-block-end:", ";", ";"], spacing16, ({
  $hasFooter
}) => $hasFooter ? spacing8 : spacing16, mediaBreak480w`
    padding: 0 ${spacing24};
    ${({
  $hasFooter
}) => $hasFooter ? `padding-block-end:  ${spacing8}` : `padding-block-end:  ${spacing24}`};
  `);
const ModalHeader = styled.header.withConfig({
  componentId: "sc-1aym6or-1"
})(["display:flex;", ";align-items:center;padding:", " ", ";padding-inline-end:", ";"], ({
  $hasHeader
}) => $hasHeader ? `justify-content: space-between; border-bottom: 1px solid ${borderColorSecondary}; margin-block-end: ${spacing24};` : "justify-content: flex-end", spacing8, spacing16, spacing8);
const ModalFooter = styled.footer.withConfig({
  componentId: "sc-1aym6or-2"
})(["position:relative;z-index:2;padding:", ";padding-block-start:", ";background:", ";", ";"], spacing16, spacing8, backgroundColorLevelCurrent, mediaBreak480w`
    padding: ${spacing24};
    padding-block-start: calc(${spacing24} - ${spacing8});
  `);

/**
 * Displays a modal dialog container primarily for holding interactive content.
 * @param {object} props - The component props
 * @param {React.ReactNode} [props.children] - Modal content
 * @param {boolean} [props.open] - Whether modal is open
 * @param {React.ReactNode} [props.header] - An element or string to display in the header slot
 * @param {React.ReactNode} [props.footer] - An element or string to display in the sticky footer slot
 * @param {(event) => void} props.onClose - Callback to execute when a close method (X, Esc key, click outside of modal) is triggered
 * @param {string} [props.closeLabel] - Label for the "close" control
 * @returns {React.ReactElement} The ToolModal component
 */
const ToolModal = ({
  children,
  header,
  footer,
  onClose,
  closeLabel = "Close",
  ...props
}) => /*#__PURE__*/_jsxs(Dialog, {
  onClose: onClose,
  ...props,
  children: [/*#__PURE__*/_jsx(Fade, {
    children: /*#__PURE__*/_jsxs(Scrollable, {
      children: [/*#__PURE__*/_jsxs(ModalHeader, {
        $hasHeader: header,
        children: [header ? /*#__PURE__*/_jsx(H5, {
          renderAs: "h2",
          children: header
        }) : null, /*#__PURE__*/_jsx(Icon, {
          size: "small",
          title: closeLabel,
          onClick: onClose,
          children: /*#__PURE__*/_jsx(Clear, {})
        })]
      }), /*#__PURE__*/_jsx(PadBox, {
        $hasFooter: footer,
        children: children
      })]
    })
  }), footer ? /*#__PURE__*/_jsx(ModalFooter, {
    children: footer
  }) : null]
});
ToolModal.displayName = "ToolModal";
export default ToolModal;